<div class="flex flex-col items-center">
	<span class="text-xl font-bold mb-2">Cancel IDV Request for:</span>

	<div class="flex flex-col text-left">
		<div *ngFor="let client of _selectedClients">
			<div class="flex gap-x-3 mt-2">
				<atomic-name-badge
					[firstName]="client.firstName"
					[lastName]="client.lastName"
					size="xsmall"
					[testHook]="testHooks.NameBadge"
				></atomic-name-badge>
				<span>{{ client.firstName }} {{ client.lastName }}</span>
			</div>
		</div>
	</div>
</div>

<div class="flex justify-between mt-6 mx-5">
	<app-button
		size="small"
		btn="border"
		(onClick)="onBackHandler()"
		[testHook]="testHooks.BackButton"
		>Back</app-button
	>
	<app-button
		size="small"
		btn="error"
		[loading]="isCancelling"
		(onClick)="cancelIDVRequest()"
		[testHook]="testHooks.Button"
		>{{ getButtonText() }}</app-button
	>
</div>
